<div class="container mt-2">
  <div class="card">
    <div class="card-body">
      <patron-tabview [tabs]="tabs" #tabview (tabChanged)="tabChanged($event)">
        <ng-template #sendingTab>
          <patron-sending-form></patron-sending-form>
        </ng-template>

        <ng-template #receivedListTab>
          <patron-paged-list #receivedPagedList [sent]="false"></patron-paged-list>
        </ng-template>

        <ng-template #sentListTab>
          <patron-paged-list #sentPagedList [sent]="true"></patron-paged-list>
        </ng-template>

        <ng-template #subscriptionTab>
          <patron-notification-configuration
            #subscriptionTemplate></patron-notification-configuration>
        </ng-template>
      </patron-tabview>
    </div>
  </div>
</div>
